module.exports = __webpack_public_path__ + "img/dsc-0070@3x.5f6fcf3a.png";